export const TEST_ID = {
  contentHub: 'contentHub',
  navCard: 'navCard',
  moreButton: 'moreButton',
};
